import { trackEvent as posthogCapture } from "@/plugins/posthog.js";
import {
  getUtmParametersFromLocalStorage,
  getDisplayMode,
  DEVICE_SPECS,
} from "@/utils/helpers.js";
import sessionTracker from "@/services/SessionTracker.js";
import trackedEvents from "./trackedEvents";

const getNativeAppVersion = () => {
  if (window.SababuuNativeBridge) {
    return {
      native_app_version: window.SababuuNativeBridge.APP_VERSION || "1.5.0",
    };
  }
  return {};
};

export const logAppBootTime = () => {
  if (window.SPLASH_PERFORMANCE?.getBootDuration) {
    const bootDuration = window.SPLASH_PERFORMANCE.getBootDuration();
    logEvent(trackedEvents.APP_BOOT_TIME, {
      app_ready_in_seconds: bootDuration
        ? convertMsToSeconds(bootDuration)
        : null,
    });
  }
};

export const convertMsToSeconds = (ms) => {
  return parseFloat((ms / 1000).toFixed(3));
};

export const logEvent = (eventName, eventParams = {}) => {
  const utmParameters = getUtmParametersFromLocalStorage();
  const nativeAppVersion = getNativeAppVersion();

  let eventProperties = {
    display_mode: getDisplayMode(),
    $session_duration: sessionTracker.getSessionDuration(),
    ...nativeAppVersion,
    ...utmParameters,
    ...eventParams,
  };

  posthogCapture(eventName, eventProperties);
};

export function getNativeAnalyticsPerson(user) {
  return {
    phone: user.phone,
    country: user.country,
    created_at: user.created_at,
    gender: user.gender,
    birthday: user.birthday,
    profile_verified: user.person_verification,
    referral_code: user.referral_code,
  };
}

export function oneSignalIdentify(
  userId,
  properties,
  { registerCompleted } = { registerCompleted: false }
) {
  if (window.SababuuNativeBridge?.oneSignalIdentifyUser) {
    window.SababuuNativeBridge.oneSignalIdentifyUser(userId, {
      device_specs: DEVICE_SPECS,
      onboarding_completed: registerCompleted,
      ...properties,
    });
  }
}

export function firebaseIdentify(
  userId,
  properties,
  { registerCompleted } = { registerCompleted: false }
) {
  if (window.SababuuNativeBridge?.firebaseIdentifyUser) {
    window.SababuuNativeBridge.firebaseIdentifyUser(userId, {
      device_specs: DEVICE_SPECS,
      onboarding_completed: registerCompleted,
      ...properties,
    });
  }
}

export function metaIdentify(userId, properties) {
  if (window.SababuuNativeBridge?.metaIdentifyUser) {
    window.SababuuNativeBridge.metaIdentifyUser(userId, properties);
  }
}

export function tikTokIdentify(userId, properties) {
  if (window.SababuuNativeBridge?.tikTokIdentifyUser) {
    window.SababuuNativeBridge.tikTokIdentifyUser(userId, properties);
  }
}
